Namespace 'Customer.Ticket'

class Customer.Ticket.TicketsByUserView extends Backbone.View
  initialize: ({ticket}) ->
    @ticket = ticket
    @stats = @ticket.getStats()

  _translatedCount: (translationString, count) ->
    "#{count} #{I18n.t(translationString, count: count)}"

  _periodToCheckMessage: ->
    switch @stats.period_to_check
      when 30, 31 then I18n.t('customer.dashboard.conversations.details.box.in_the_last_month')
      when 10000 then ''
      else @_lastXDaysMessage()

  _lastXDaysMessage: ->
    I18n.t('customer.dashboard.conversations.details.box.in_the_last_x_days', periodToCheck: @stats.period_to_check)
